import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/verifikasiPenelitian',
    name: 'verfikasiPenelitian',
    component: () => import('../views/verifikasi/verifikasiPenelitian.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/verifikasiUsulan',
    name: 'verfikasiUsulan',
    component: () => import('../views/verifikasi/verifikasiUsulan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/verifikasiInotek',
    name: 'verfikasiInotek',
    component: () => import('../views/verifikasi/verifikasiSida.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/profil',
    name: 'profil',
    component: () => import('../views/profil.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: () => import('../views/dokumen.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/panduan',
    name: 'panduan',
    component: () => import('../views/panduan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/berita',
    name: 'berita',
    component: () => import('../views/berita.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/foto',
    name: 'foto',
    component: () => import('../views/foto.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('../views/video.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/usulan',
    name: 'usulan',
    component: () => import('../views/usulan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/penelitian',
    name: 'penelitian',
    component: () => import('../views/penelitian.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/inotek',
    name: 'inotek',
    component: () => import('../views/sida.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/inovasi',
    name: 'inovasi',
    component: () => import('../views/inovasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/artikel',
    name: 'artikel',
    component: () => import('../views/artikel.vue'),
    beforeEnter: isLoggedIn,
  },  
  {
    path: '/pengguna',
    name: 'pengguna',
    component: () => import('../views/pengguna.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/tahun',
    name: 'tahun',
    component: () => import('../views/tahun.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/riset',
    name: 'riset',
    component: () => import('../views/riset.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/teknologi',
    name: 'teknologi',
    component: () => import('../views/teknologi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/iid',
    name: 'iid',
    component: () => import('../views/iid.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ipkd',
    name: 'ipkd',
    component: () => import('../views/ipkd.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/idsd',
    name: 'idsd',
    component: () => import('../views/idsd.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/haki',
    name: 'haki',
    component: () => import('../views/haki.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ikm',
    name: 'ikm',
    component: () => import('../views/ikm.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/krenova',
    name: 'krenova',
    component: () => import('../views/krenova.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/tim',
    name: 'tim',
    component: () => import('../views/tim.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/perubahan',
    name: 'perubahan',
    component: () => import('../views/perubahan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/tema',
    name: 'tema',
    component: () => import('../views/tema.vue'),
    beforeEnter: isLoggedIn,
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
